import React, { useEffect, useRef, useState } from 'react';
import TransactionFlowDiagram from './TransactionFlowDiagram';
import CryptoTransactionFlow from './CryptoTransactionFlow';

interface PDFChartRendererProps {
  traceData: any;
  onChartsReady: (spiderElement: HTMLElement | null, flowElement: HTMLElement | null) => void;
}

const PDFChartRenderer: React.FC<PDFChartRendererProps> = ({ traceData, onChartsReady }) => {
  const spiderRef = useRef<HTMLDivElement>(null);
  const flowRef = useRef<HTMLDivElement>(null);
  const [spiderReady, setSpiderReady] = useState(false);
  const [flowReady, setFlowReady] = useState(false);

  useEffect(() => {
    if (spiderReady && flowReady) {
      // Wait a bit more for full rendering
      setTimeout(() => {
        onChartsReady(
          spiderRef.current,
          flowRef.current
        );
      }, 1000);
    }
  }, [spiderReady, flowReady, onChartsReady]);

  if (!traceData) {
    return null;
  }

  return (
    <div 
      style={{
        position: 'absolute',
        top: '-9999px',
        left: '-9999px',
        width: '1200px',
        height: '800px',
        backgroundColor: '#ffffff',
        zIndex: -1,
        visibility: 'visible', // Always visible for PDF capture
        overflow: 'hidden'
      }}
    >
      {/* Spider Diagram for PDF */}
      <div 
        ref={spiderRef}
        data-diagram="spider-pdf"
        style={{
          width: '1200px',
          height: '400px',
          marginBottom: '20px',
          border: '1px solid #ddd',
          backgroundColor: '#ffffff'
        }}
      >
        <TransactionFlowDiagram 
          traceData={traceData} 
          onRenderComplete={() => setSpiderReady(true)}
        />
      </div>
      
      {/* Flow Diagram for PDF */}
      <div 
        ref={flowRef}
        data-diagram="flow-pdf"
        style={{
          width: '1200px',
          height: '400px',
          border: '1px solid #ddd',
          backgroundColor: '#ffffff'
        }}
      >
        <CryptoTransactionFlow 
          traceData={traceData}
          onRenderComplete={() => setFlowReady(true)}
        />
      </div>
    </div>
  );
};

export default PDFChartRenderer;
